import React,{useEffect} from "react";
import { decideProductPage } from "./decide_product_page";
import { hideShowPromoLayer, togglePromoLayerBasedOnDevice } from "./hide_show_promo_layer";


const redirectToLoginPage=()=>{
    photoOrg.Util.getLoginRedirectUrl(true);
}


const SitePromo= () => {

    useEffect(()=>{
        togglePromoLayerBasedOnDevice();
    },[togglePromoLayerBasedOnDevice])

    const listOfDesktopLinks = photoOrg.config.product_details_share.products.map((pd)=>{
        return(
            <li key={pd.name}>
                <a onClick={(e)=>decideProductPage(e)} data-testid="btn_login_signin" className ="product-links-share" href="#" type={pd.name} id={pd.name}>
                    <figure className={pd.name}></figure>
                    <span>{photoOrg.translations.photos["action_container"]["make_" + pd["i18n_text_key"]]}</span>
                </a>
            </li>
        )
    })
   
    return(
      <div id="site_promo" className="join-sec" name="public_share_promo_layer" >
         <div onClick={(e)=>hideShowPromoLayer(e)} data-testid="btn_hide_promo" className="title info_click">
             <a className="arrow" href="#" ><span></span> </a>
             {photoOrg.translations.photos["action_container"]["promo_head_info"]}
          </div>
          <div className="row">
              <div className="small-12 medium-8 large-6 medium-centered columns join_description">
              {photoOrg.translations.photos["action_container"]["promo_description"]}
              </div>
           </div>
           <div className="public-share-product-links">
               {(window.innerWidth >= "640") ? 
               <div className="desktop-product-links">
                   <ul>
                       {listOfDesktopLinks}
                   </ul> 
               </div> : 
               <div className="mobile-product-links"> 
                   <ul>
                       {listOfDesktopLinks}
                   </ul>

                </div>}
            </div>
           <a onClick={()=>redirectToLoginPage()} data-testid="btn_loginPage" className="join_site_share share_login_link" name="public_share_join_site" href="#" >{photoOrg.translations.photos["action_container"]["join_site"]}</a>
     </div>
    )
}

export default SitePromo;